import { Rating } from "react-simple-star-rating";
import "../ratingwrapper.css"

function RatingWrapper({ rating, title }) {

    return (
        <div className="ratingwrapper">
            <Rating initialValue={rating} allowFraction={true} readonly={true} size={30} />
            <br />
            <strong>{title}</strong>
        </div>
    )
}

export default RatingWrapper;